<template>
  <div class="AddLessonContentModal">
    <CorrectPolyPhoneModal
        ref="CorrectPolyPhoneModal"
        @refreshInputVal="refreshInputVal"
        :inputValArr="inputValArr"
    ></CorrectPolyPhoneModal>
    <el-dialog
        :title="dialogTitle"
        :visible.sync="visible"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        @open="handleOpen"
    >
      <SearchKnowledge v-if="addType!='view'"></SearchKnowledge>
      <!--公共部分-->
      <template>
        <div v-if="formData.type !== 'richText'" class="title">课程内容</div>
        <div v-else class="title">请输入下节内容引导语</div>
        <el-form
            ref="form"
            :model="formData"
            :rules="rules"
            size="mini"
            label-width="90px"
        >
          <template v-if="formData.type !== 'richText'">
            <template v-if="!isSituational">
              <template
                  v-if="
                  formData.type === 'text' || formData.type === 'dialogSelect'
                "
              >
                <el-form-item label="当前角色:" prop="role">
                  <el-radio-group v-model="formData.role" :disabled="addType=='view'">
                    <el-radio
                        v-for="item in roleArrStudent"
                        :key="item.value"
                        :label="item.label"
                    ></el-radio>
                  </el-radio-group>
                </el-form-item>
              </template>
              <template v-else>
                <el-form-item label="当前角色:" prop="role">
                  <el-radio-group v-model="formData.role" :disabled="addType=='view'">
                    <el-radio
                        v-for="item in roleArr"
                        :key="item.value"
                        :label="item.label"
                    ></el-radio>
                  </el-radio-group>
                </el-form-item>
              </template>
              <template></template>
            </template>
            <el-form-item label="内容类型:" prop="type">
              <el-radio-group
                  v-model="formData.type"
                  @change="handleChangeType"
                  :disabled="addType=='view'"
              >
                <el-radio
                    style="min-width: 115px; margin-top: 10px; margin-left: 0px"
                    border
                    v-for="(item, index) in 内容文件选项"
                    :key="index"
                    :label="item.value"
                >{{ item.label }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </template>
          <!--不同内容的切换-->
          <div class="contentChangeBox">
            <!--            点击题干转音频  单选 多选 判断 排序 问答题 图片选择-->
            <template
                v-if="
                formData.type === 'select' ||
                formData.type === 'multipleSelect' ||
                formData.type === 'judge' ||
                formData.type === 'sort' ||
                formData.type === 'text' ||
                formData.type === 'imageSelect'
              "
            >
              <!--              <template-->
              <!--                v-if="!formData.lessonContentTemplate.question.titleAudio"-->
              <!--              >-->
              <div class="unShowStar">
                <el-form-item
                    label="文字题干:"
                    prop="lessonContentTemplate.question.title"
                >
                  <!--                  <div style="margin-bottom: 10px">-->
                  <!--                    <el-button size="mini" type="primary" plain-->
                  <!--                      >文字题干-->
                  <!--                    </el-button>-->
                  <!--                    <el-button-->
                  <!--                      size="mini"-->
                  <!--                      type="info"-->
                  <!--                      plain-->
                  <!--                      @click="-->
                  <!--                        handleToggleVideo(-->
                  <!--                          1,-->
                  <!--                          formData.lessonContentTemplate.question.title-->
                  <!--                        )-->
                  <!--                      "-->
                  <!--                      >音频题干-->
                  <!--                    </el-button>-->
                  <!--                  </div>-->
                  <el-input
                      style="height: 100px"
                      type="textarea"
                      placeholder="为保证显示质量，文字题干不得超过110字"
                      v-model="formData.lessonContentTemplate.question.title"
                  ></el-input>
                </el-form-item>
              </div>
              <!--              </template>-->
              <!--              <template v-else>-->
              <el-form-item label="音频题干:">
                <!--                  <div style="margin-bottom: 10px">-->
                <!--                    <el-button-->
                <!--                      size="mini"-->
                <!--                      type="info"-->
                <!--                      plain-->
                <!--                      @click="-->
                <!--                        handleToggleVideo(-->
                <!--                          2,-->
                <!--                          formData.lessonContentTemplate.materials[0].audioText-->
                <!--                        )-->
                <!--                      "-->
                <!--                      >文字题干-->
                <!--                    </el-button>-->
                <!--                    <el-button size="mini" type="primary" plain-->
                <!--                      >音频题干-->
                <!--                    </el-button>-->
                <!--                  </div>-->
                <AppSsmlEditor
                    ref="questionEdit"
                    :type="'question'"
                    :audioText="
                    formData.lessonContentTemplate.materials[0].audioText
                  "
                    :blankWarning="blankWarning"
                    @handleChange="handleChange"
                ></AppSsmlEditor>
              </el-form-item>
              <div class="changeTitleTypeBox">
                <div>
                  <span>声音属性： </span>
                  <el-radio-group
                      v-model="formData.lessonContentTemplate.materials[0].voice"
                  >
                    <el-radio
                        v-for="item in humanOption"
                        :key="item.value"
                        :label="item.value"
                        :disabled="creatAudioLoading"
                    >{{ item.label }}
                    </el-radio>
                  </el-radio-group>
                  <div>
                    <div style="margin-top: 15px; margin-bottom: 15px">
                      <span>播放速度： </span>
                      <el-radio-group
                          v-model="
                          formData.lessonContentTemplate.materials[0].speechRate
                        "
                      >
                        <el-radio
                            v-for="item in rateArr"
                            :key="item.value"
                            :label="item.value"
                            :disabled="creatAudioLoading"
                        >{{ item.label }}
                        </el-radio>
                      </el-radio-group>
                    </div>
                    <div
                        v-if="
                        formData.lessonContentTemplate.materials[0].materialUrl
                      "
                        style="
                        display: flex;
                        justify-content: flex-start;
                        align-items: center;
                      "
                    >
                      <div>点击试听:</div>
                      <div>
                        <audio
                            :src="
                            formData.lessonContentTemplate.materials[0]
                              .materialUrl
                          "
                            :loop="false"
                            controls
                            preload="auto"
                            controlsList="nodownload noplaybackrate"
                            ref="audioRef"
                        ></audio>
                      </div>
                      <div>
                        <el-button
                            size="mini"
                            type="primary"
                            @click="handleDeleteGroupTitleAudio"
                            :showForRead="addType=='view'"
                        >清除音频
                        </el-button>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <el-button
                      size="mini"
                      type="primary"
                      @click="handleGroupTitleAudioPolyPhone"
                      :showForRead="addType=='view'"
                  >多音字
                  </el-button>
                  <el-button
                      size="mini"
                      type="primary"
                      :loading="creatAudioLoading"
                      @click="handleGroupTitleAudio"
                      :showForRead="addType=='view'"
                  >生成音频
                  </el-button>
                </div>
              </div>
              <!--              </template>-->
            </template>
            <!--文本转语音-->
            <template v-if="formData.type === 'audioText'">
              <el-form-item label="音频内容:">
                <AppSsmlEditor
                    :showForRead="addType=='view'"
                    ref="audioTextEdit"
                    :type="'audioText'"
                    :audioText="formData.lessonContentTemplate.material.audioText"
                    @handleChangeTitleAudio="handleChangeTitleAudio"
                ></AppSsmlEditor>
              </el-form-item>
              <div class="changeTitleTypeBox">
                <div>
                  <span>声音属性： </span>
                  <el-radio-group
                      v-model="formData.lessonContentTemplate.material.voice"
                  >
                    <el-radio
                        v-for="item in humanOption"
                        :key="item.value"
                        :label="item.value"
                        :disabled="creatAudioLoading||addType=='view'"
                    >{{ item.label }}
                    </el-radio>
                  </el-radio-group>
                  <div>
                    <div style="margin-top: 15px; margin-bottom: 15px">
                      <span>播放速度： </span>
                      <el-radio-group
                          v-model="
                          formData.lessonContentTemplate.material.speechRate
                        "
                      >
                        <el-radio
                            v-for="item in rateArr"
                            :key="item.value"
                            :label="item.value"
                            :disabled="creatAudioLoading||addType=='view'"
                        >{{ item.label }}
                        </el-radio>
                      </el-radio-group>
                    </div>
                    <div
                        v-if="formData.lessonContentTemplate.material.materialUrl"
                        style="
                        display: flex;
                        justify-content: flex-start;
                        align-items: center;
                      "
                    >
                      <div>点击试听:</div>
                      <div>
                        <audio
                            :src="
                            formData.lessonContentTemplate.material.materialUrl
                          "
                            :loop="false"
                            controls
                            preload="auto"
                            controlsList="nodownload noplaybackrate"
                            ref="audioRef"
                        ></audio>
                      </div>
                      <div>
                        <el-button
                            size="mini"
                            type="primary"
                            @click="handleDeleteTitleAudio"
                            :disabled="addType=='view'"
                        >清除音频
                        </el-button>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <el-button
                      size="mini"
                      type="primary"
                      @click="handleTitleAudioPolyPhone"
                      :disabled="addType=='view'"
                  >多音字
                  </el-button>
                  <el-button
                      size="mini"
                      type="primary"
                      :loading="creatAudioLoading"
                      @click="handleTitleAudio"
                      :disabled="addType=='view'"
                  >生成音频
                  </el-button>
                </div>
              </div>
              <div class="unShowStar">
                <el-form-item
                    label="展示文字:"
                    prop="lessonContentTemplate.material.displayAudioText"
                >
                  <el-input
                      type="textarea"
                      placeholder="不得超过78字"
                      v-model="
                      formData.lessonContentTemplate.material.displayAudioText
                    "
                      :disabled="addType=='view'"
                  ></el-input>
                </el-form-item>
              </div>
              <div style="text-align: right">
                <el-checkbox-group
                    v-model="markDownCheckBoxVal"
                    @change="handleMarkDown"
                    :disabled="addType=='view'"
                >
                  <el-checkbox
                      v-model="formData.lessonContentTemplate.material.markFlag"
                      :checked="
                      formData.lessonContentTemplate.material.markFlag === 1
                    "
                      :disabled="
                      formData.lessonContentTemplate.material
                        .displayAudioText &&
                      formData.lessonContentTemplate.material.displayAudioText.trim()
                        .length < 1
                    "
                      label="知识点回顾"
                      size="mini"
                  ></el-checkbox>
                </el-checkbox-group>
                <!--                <el-button-->
                <!--                  :disabled="-->
                <!--                    formData.lessonContentTemplate.material.displayAudioText &&-->
                <!--                    formData.lessonContentTemplate.material.displayAudioText.trim()-->
                <!--                      .length < 1-->
                <!--                  "-->
                <!--                  size="mini"-->
                <!--                  type="primary"-->
                <!--                  @click="handleMarkDown"-->
                <!--                  >保存到知识回顾-->
                <!--                </el-button>-->
              </div>
            </template>
            <!--视频-->
            <template v-if="formData.type === 'video'">
              <el-form-item label="上传视频:">
                <template v-if="videoUrl">
                  <y-j-video
                      style="width: 400px; height: 200px"
                      :src="videoUrl"
                  />
                  <div style="text-align: right; width: 400px">
                    <el-button
                        :disabled="addType=='view'"
                        class="btn"
                        size="mini"
                        type="primary"
                        @click="handleUploadNewVideo"
                    >重新上传
                    </el-button>
                  </div>
                </template>
                <template v-else>
                  <el-upload
                      v-loading="loading"
                      element-loading-text="上传中，请勿操作"
                      element-loading-spinner="el-icon-loading"
                      element-loading-background="rgba(0, 0, 0, 0.8)"
                      drag
                      action="#"
                      :auto-upload="false"
                      :show-file-list="false"
                      :before-upload="beforeUploadVideo"
                      :on-change="handleVideoChange"
                  >
                    <i class="el-icon-upload"></i>
                    <div>
                      <el-button
                          class="btn"
                          size="mini"
                          type="primary"
                          slot="trigger"
                          :disabled="addType=='view'"
                      >上传视频
                      </el-button>
                      <el-button
                          class="btn"
                          size="mini"
                          plain
                          type="primary"
                          slot="trigger"
                          :disabled="addType=='view'"
                      >素材库
                      </el-button>
                    </div>
                  </el-upload>
                </template>
              </el-form-item>
            </template>
            <!--            图片-->
            <template v-if="formData.type === 'image'">
              <el-form-item label="图片：">
                <div class="itemBox">
                  <el-upload
                      v-loading="loading"
                      element-loading-text="上传中，请勿操作"
                      element-loading-spinner="el-icon-loading"
                      element-loading-background="rgba(0, 0, 0, 0.8)"
                      action="#"
                      :show-file-list="false"
                      :auto-upload="false"
                      :on-change="handleImgChange"
                      :before-upload="beforeImageUpload"
                  >
                    <img
                        v-if="imageUrl"
                        :src="imageUrl"
                        class="avatar"
                        alt=""
                    />
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    <div>
                      <el-button
                          class="btn"
                          v-if="imageUrl"
                          size="mini"
                          plain
                          type="primary"
                          slot="trigger"
                          :disabled="addType=='view'"
                      >重新上传
                      </el-button>
                      <el-button
                          class="btn"
                          v-else
                          size="mini"
                          type="primary"
                          slot="trigger"
                          :disabled="addType=='view'"
                      >上传图片
                      </el-button>
                      <el-button
                          class="btn"
                          size="mini"
                          plain
                          type="primary"
                          slot="trigger"
                          :disabled="addType=='view'"
                      >素材库
                      </el-button>
                    </div>
                  </el-upload>
                </div>
              </el-form-item>
            </template>
            <!--            聊天框选择-->
            <template v-if="formData.type === 'dialogSelect'">
              <el-form-item
                  label="选项A"
                  prop="lessonContentTemplate.question.item[0]"
              >
                <el-input
                    type="textarea"
                    v-model="formData.lessonContentTemplate.question.item[0]"
                    :disabled="addType=='view'"
                ></el-input>
              </el-form-item>
              <el-form-item
                  label="选项B"
                  prop="lessonContentTemplate.question.item[1]"
              >
                <el-input
                    type="textarea"
                    v-model="formData.lessonContentTemplate.question.item[1]"
                    :disabled="addType=='view'"
                ></el-input>
              </el-form-item>
            </template>
            <!--            问答题-->
            <!--            <template v-if="formData.type === 'text'">-->
            <!--              <el-form-item-->
            <!--                label="题干:"-->
            <!--                prop="lessonContentTemplate.text.item[0]"-->
            <!--              >-->
            <!--                <el-input-->
            <!--                  type="textarea"-->
            <!--                  v-model="formData.lessonContentTemplate.text.item[0]"-->
            <!--                ></el-input>-->
            <!--              </el-form-item>-->
            <!--            </template>-->
            <!--            单选题-->
            <template v-if="formData.type === 'select'">
              <el-form-item
                  label="选项A"
                  prop="lessonContentTemplate.question.item[0]"
              >
                <el-input
                    v-model="formData.lessonContentTemplate.question.item[0]"
                    maxlength="28"
                    show-word-limit
                    placeholder="不得超过28个文字"
                    :disabled="addType=='view'"
                ></el-input>
              </el-form-item>
              <el-form-item
                  label="选项B"
                  prop="lessonContentTemplate.question.item[1]"
              >
                <el-input
                    v-model="formData.lessonContentTemplate.question.item[1]"
                    maxlength="28"
                    show-word-limit
                    placeholder="不得超过28个文字"
                    :disabled="addType=='view'"
                ></el-input>
              </el-form-item>
              <el-form-item label="选项C">
                <el-input
                    v-model="formData.lessonContentTemplate.question.item[2]"
                    maxlength="28"
                    show-word-limit
                    placeholder="不得超过28个文字"
                ></el-input>
              </el-form-item>
              <el-form-item label="选项D">
                <el-input
                    v-model="formData.lessonContentTemplate.question.item[3]"
                    maxlength="28"
                    show-word-limit
                    placeholder="不得超过28个文字"
                    :disabled="addType=='view'"
                ></el-input>
              </el-form-item>
              <el-form-item
                  label="正确选项"
                  prop="lessonContentTemplate.question.answer[0]"
              >
                <el-select
                    style="width: 100%"
                    v-model="formData.lessonContentTemplate.question.answer[0]"
                    placeholder="请选择正确选项"
                    @change="handleSelectAnswer"
                    :disabled="addType=='view'"
                >
                  <el-option
                      v-for="item in selectTrueOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </template>
            <!--            多选题-->
            <template v-if="formData.type === 'multipleSelect'">
              <el-form-item
                  label="选项A"
                  prop="lessonContentTemplate.question.item[0]"
              >
                <el-input
                    v-model="formData.lessonContentTemplate.question.item[0]"
                    maxlength="28"
                    show-word-limit
                    placeholder="不得超过28个文字"
                    :disabled="addType=='view'"
                ></el-input>
              </el-form-item>
              <el-form-item
                  label="选项B"
                  prop="lessonContentTemplate.question.item[1]"
              >
                <el-input
                    v-model="formData.lessonContentTemplate.question.item[1]"
                    maxlength="28"
                    show-word-limit
                    placeholder="不得超过28个文字"
                    :disabled="addType=='view'"
                ></el-input>
              </el-form-item>
              <el-form-item
                  label="选项C"
                  prop="lessonContentTemplate.question.item[2]"
              >
                <el-input
                    v-model="formData.lessonContentTemplate.question.item[2]"
                    maxlength="28"
                    show-word-limit
                    placeholder="不得超过28个文字"
                    :disabled="addType=='view'"
                ></el-input>
              </el-form-item>
              <el-form-item label="选项D">
                <el-input
                    v-model="formData.lessonContentTemplate.question.item[3]"
                    maxlength="28"
                    show-word-limit
                    placeholder="不得超过28个文字"
                    :disabled="addType=='view'"
                ></el-input>
              </el-form-item>
              <el-form-item label="选项E">
                <el-input
                    v-model="formData.lessonContentTemplate.question.item[4]"
                    maxlength="28"
                    show-word-limit
                    placeholder="不得超过28个文字"
                    :disabled="addType=='view'"
                ></el-input>
              </el-form-item>
              <el-form-item label="选项F">
                <el-input
                    v-model="formData.lessonContentTemplate.question.item[5]"
                    maxlength="28"
                    show-word-limit
                    placeholder="不得超过28个文字"
                    :disabled="addType=='view'"
                ></el-input>
              </el-form-item>
              <el-form-item label="选项G">
                <el-input
                    v-model="formData.lessonContentTemplate.question.item[6]"
                    maxlength="28"
                    show-word-limit
                    placeholder="不得超过28个文字"
                    :disabled="addType=='view'"
                ></el-input>
              </el-form-item>
              <el-form-item label="选项H">
                <el-input
                    v-model="formData.lessonContentTemplate.question.item[7]"
                    maxlength="28"
                    show-word-limit
                    placeholder="不得超过28个文字"
                    :disabled="addType=='view'"
                ></el-input>
              </el-form-item>
              <el-form-item
                  label="正确选项"
                  prop="lessonContentTemplate.question.answer[0]"
              >
                <el-checkbox-group
                    v-model="formData.lessonContentTemplate.question.answer"
                    :disabled="addType=='view'"
                >
                  <el-checkbox
                      v-for="item in multipleSelectTrueOptions"
                      :key="item.value"
                      :label="item.value"
                      :disabled="
                      !formData.lessonContentTemplate.question.item[
                        item.value
                      ] ||
                      formData.lessonContentTemplate.question.item[
                        item.value
                      ].trim().length === 0
                    "
                  >
                    {{ item.label }}
                  </el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </template>
            <!--            判断题-->
            <template v-if="formData.type === 'judge'">
              <el-form-item
                  label="正确选项:"
                  prop="lessonContentTemplate.question.answer[0]"
              >
                <el-select
                    style="width: 100%"
                    v-model="formData.lessonContentTemplate.question.answer[0]"
                    placeholder="请选择正确选项"
                    :disabled="addType=='view'"
                >
                  <el-option
                      v-for="item in judgeTrueOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </template>
            <!--            排序题-->
            <template v-if="formData.type === 'sort'">
              <el-form-item
                  label="1"
                  prop="lessonContentTemplate.question.item[0]"
              >
                <el-input
                    v-model="formData.lessonContentTemplate.question.item[0]"
                    maxlength="28"
                    show-word-limit
                    placeholder="不得超过28个文字"
                    :disabled="addType=='view'"
                ></el-input>
              </el-form-item>
              <el-form-item
                  label="2"
                  prop="lessonContentTemplate.question.item[1]"
              >
                <el-input
                    v-model="formData.lessonContentTemplate.question.item[1]"
                    maxlength="28"
                    show-word-limit
                    placeholder="不得超过28个文字"
                    :disabled="addType=='view'"
                ></el-input>
              </el-form-item>
              <el-form-item
                  label="3"
                  prop="lessonContentTemplate.question.item[2]"
              >
                <el-input
                    v-model="formData.lessonContentTemplate.question.item[2]"
                    maxlength="28"
                    show-word-limit
                    placeholder="不得超过28个文字"
                    :disabled="addType=='view'"
                ></el-input>
              </el-form-item>
              <el-form-item label="4">
                <el-input
                    v-model="formData.lessonContentTemplate.question.item[3]"
                    maxlength="28"
                    show-word-limit
                    placeholder="不得超过28个文字"
                    :disabled="addType=='view'"
                ></el-input>
              </el-form-item>
              <el-form-item label="5">
                <el-input
                    v-model="formData.lessonContentTemplate.question.item[4]"
                    maxlength="28"
                    show-word-limit
                    placeholder="不得超过28个文字"
                    :disabled="addType=='view'"
                ></el-input>
              </el-form-item>
              <el-form-item label="6">
                <el-input
                    v-model="formData.lessonContentTemplate.question.item[5]"
                    maxlength="28"
                    show-word-limit
                    placeholder="不得超过28个文字"
                    :disabled="addType=='view'"
                ></el-input>
              </el-form-item>
              <el-form-item label="7">
                <el-input
                    v-model="formData.lessonContentTemplate.question.item[6]"
                    maxlength="28"
                    show-word-limit
                    placeholder="不得超过28个文字"
                    :disabled="addType=='view'"
                ></el-input>
              </el-form-item>
              <el-form-item label="8">
                <el-input
                    v-model="formData.lessonContentTemplate.question.item[7]"
                    maxlength="28"
                    show-word-limit
                    placeholder="不得超过28个文字"
                    :disabled="addType=='view'"
                ></el-input>
              </el-form-item>
              <el-form-item label="正确顺序" class="sortBox">
                <el-input
                    :class="isRequiredSort ? 'requiredSort' : ''"
                    type="number"
                    v-model="sortTrueAnswer"
                    minlength="3"
                    maxlength="5"
                    placeholder="请输入正确的排列顺序，示例：42315"
                    :disabled="addType=='view'"
                ></el-input>
                <span v-if="isRequiredSort" style="color: #f56c6c">请输入</span>
              </el-form-item>
            </template>
            <!--            图片选择-->
            <template v-if="formData.type === 'imageSelect'">
              <el-form-item label="选项A:">
                <div class="itemBox">
                  <el-upload
                      v-loading="loadingA"
                      element-loading-text="上传中，请勿操作"
                      element-loading-spinner="el-icon-loading"
                      element-loading-background="rgba(0, 0, 0, 0.8)"
                      action="#"
                      :show-file-list="false"
                      :auto-upload="false"
                      :on-change="handleImgSelectChangeA"
                      :before-upload="beforeImgSelectUploadA"
                  >
                    <img
                        v-if="imageSelectUrlA"
                        :src="imageSelectUrlA"
                        class="avatar"
                        alt=""
                    />
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    <div>
                      <el-button
                          class="btn"
                          v-if="imageSelectUrlA"
                          size="mini"
                          plain
                          type="primary"
                          slot="trigger"
                          :disabled="addType=='view'"
                      >重新上传
                      </el-button>
                      <el-button
                          class="btn"
                          v-else
                          size="mini"
                          type="primary"
                          slot="trigger"
                          :disabled="addType=='view'"
                      >上传图片
                      </el-button>
                      <el-button
                          class="btn"
                          size="mini"
                          plain
                          type="primary"
                          slot="trigger"
                          :disabled="addType=='view'"
                      >素材库
                      </el-button>
                    </div>
                  </el-upload>
                </div>
              </el-form-item>
              <el-form-item label="选项B:">
                <div class="itemBox">
                  <el-upload
                      v-loading="loadingB"
                      element-loading-text="上传中，请勿操作"
                      element-loading-spinner="el-icon-loading"
                      element-loading-background="rgba(0, 0, 0, 0.8)"
                      action="#"
                      :show-file-list="false"
                      :auto-upload="false"
                      :on-change="handleImgSelectChangeB"
                      :before-upload="beforeImgSelectUploadB"
                  >
                    <img
                        v-if="imageSelectUrlB"
                        :src="imageSelectUrlB"
                        class="avatar"
                        alt=""
                    />
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    <div>
                      <el-button
                          class="btn"
                          v-if="imageSelectUrlB"
                          size="mini"
                          plain
                          type="primary"
                          slot="trigger"
                          :disabled="addType=='view'"
                      >重新上传
                      </el-button>
                      <el-button
                          class="btn"
                          v-else
                          size="mini"
                          type="primary"
                          slot="trigger"
                          :disabled="addType=='view'"
                      >上传图片
                      </el-button>
                      <el-button
                          class="btn"
                          size="mini"
                          plain
                          type="primary"
                          slot="trigger"
                          :disabled="addType=='view'"
                      >素材库
                      </el-button>
                    </div>
                  </el-upload>
                </div>
              </el-form-item>
              <el-form-item
                  label="正确选项:"
                  prop="lessonContentTemplate.question.answer[0]"
              >
                <el-select
                    style="width: 100%"
                    v-model="formData.lessonContentTemplate.question.answer[0]"
                    placeholder="请选择正确选项"
                    @change="handleImageTrueAnswer"
                    :disabled="addType=='view'"
                >
                  <el-option
                      v-for="item in imageSelectAnswerOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </template>
            <!--            下节引入只有富文本-->
            <template v-if="formData.type === 'richText'">
              <el-form-item style="margin-left: 10px" label-width="0px">
                <el-input
                    style="height: 100px"
                    type="textarea"
                    placeholder="请确认当前课程非系列课程最后一课后，输入下节引入内容。可输入一段文本、一张图片，按完成按钮结束。"
                    v-model="formData.lessonContentTemplate.text.item[0]"
                    :disabled="addType=='view'"
                ></el-input>
              </el-form-item>
              <el-form-item style="margin-left: 10px" label-width="0px">
                <el-upload
                    v-loading="loading"
                    element-loading-text="上传中，请勿操作"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(0, 0, 0, 0.8)"
                    action="#"
                    :show-file-list="false"
                    :auto-upload="false"
                    :on-change="handleImgChange"
                    :before-upload="beforeImageUpload"
                >
                  <img v-if="imageUrl" :src="imageUrl" class="avatar" alt=""/>
                  <i
                      v-else
                      style="background: #ffffff"
                      class="el-icon-plus avatar-uploader-icon"
                  ></i>
                  <div>
                    <el-button
                        class="btn"
                        v-if="imageUrl"
                        size="mini"
                        plain
                        type="primary"
                        slot="trigger"
                        :disabled="addType=='view'"
                    >重现上传
                    </el-button>
                    <el-button
                        class="btn"
                        v-else
                        size="mini"
                        type="primary"
                        slot="trigger"
                        :disabled="addType=='view'"
                    >上传图片
                    </el-button>
                    <el-button
                        class="btn"
                        size="mini"
                        plain
                        type="primary"
                        slot="trigger"
                        :disabled="addType=='view'"
                    >素材库
                    </el-button>
                  </div>
                </el-upload>
              </el-form-item>
            </template>
            <template v-if="isSituational">
              <el-form-item
                  label="下方为错题讲解部分："
                  label-width="170px"
              ></el-form-item>
              <el-form-item label="音频讲解:">
                <AppSsmlEditor
                    ref="explainEdit"
                    :type="'explain'"
                    :audioText="
                    formData.lessonContentTemplate.materials[3].audioText
                  "
                    @handleChangeSayAudio="handleChangeSayAudio"
                ></AppSsmlEditor>
              </el-form-item>
              <div class="changeTitleTypeBox">
                <div>
                  <span>声音属性： </span>
                  <el-radio-group
                      v-model="formData.lessonContentTemplate.materials[3].voice"
                  >
                    <el-radio
                        v-for="item in humanOption"
                        :key="item.value"
                        :label="item.value"
                        :disabled="creatAudioLoading"
                    >{{ item.label }}
                    </el-radio>
                  </el-radio-group>
                  <div>
                    <div style="margin-top: 15px; margin-bottom: 15px">
                      <span>播放速度： </span>
                      <el-radio-group
                          v-model="
                          formData.lessonContentTemplate.materials[3].speechRate
                        "
                      >
                        <el-radio
                            v-for="item in rateArr"
                            :key="item.value"
                            :label="item.value"
                            :disabled="creatAudioLoading"
                        >{{ item.label }}
                        </el-radio>
                      </el-radio-group>
                    </div>
                    <div
                        v-if="
                        formData.lessonContentTemplate.materials[3].materialUrl
                      "
                        style="
                        display: flex;
                        justify-content: flex-start;
                        align-items: center;
                      "
                    >
                      <div>点击试听:</div>
                      <div>
                        <audio
                            :src="
                            formData.lessonContentTemplate.materials[3]
                              .materialUrl
                          "
                            :loop="false"
                            controls
                            preload="auto"
                            controlsList="nodownload noplaybackrate"
                            ref="audioRef"
                        ></audio>
                      </div>
                      <div>
                        <el-button
                            size="mini"
                            type="primary"
                            @click="handleDeleteSayAudio"
                        >清除音频
                        </el-button>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <el-button
                      size="mini"
                      type="primary"
                      @click="handleSayAudioPolyPhone"
                  >多音字
                  </el-button>
                  <el-button
                      size="mini"
                      type="primary"
                      @click="handleSayAudio"
                      :loading="creatSayAudioLoading"
                  >生成音频
                  </el-button>
                </div>
              </div>
              <el-form-item
                  label="文字："
                  prop="lessonContentTemplate.question.displayExplain"
              >
                <el-input
                    type="textarea"
                    v-model="
                    formData.lessonContentTemplate.question.displayExplain
                  "
                    placeholder="请根据音频摘抄核心内容，文字不超过140字"
                ></el-input>
              </el-form-item>
            </template>
          </div>
        </el-form>
      </template>
      <template v-if="addType === 'add'">
        <div class="footer">
          <div>
            <el-button @click="handleSave">保存查看</el-button>
          </div>
          <div>
            <el-button type="primary" @click="handleAdd">继续添加</el-button>
          </div>
        </div>
        <template v-if="!isLast">
          <div class="footer">
            <el-button type="primary" @click="handleNextModule"
            >进入下一环节
            </el-button>
          </div>
        </template>
        <template v-else>
          <div class="footer">
            <el-button type="primary" @click="handleFinished">完成</el-button>
          </div>
        </template>
      </template>
      <template v-else>
        <div class="footer">
          <el-button v-if="addType === 'view'" type="primary" @click="handleClose">关闭</el-button>
          <el-button v-else type="primary" @click="handleFinished">完成</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";
import {addLessonContentMixins} from "@/pages/MyOutLine/addLessonContentMixins";
import {MODULE_TYPE} from "@/utils/constants";
import AppSsmlEditor from "./SsmlEditor.vue";
import CorrectPolyPhoneModal from "./CorrectPolyPhoneModal.vue";
import SearchKnowledge from "@/pages/MyOutLine/SearchKnowledge.vue";
import YJVideo from "@/components/video/index.vue";

export default {
  name: "AddLessonContentModal",
  props: {
    addType: {
      type: String,
      default: "add",
    },
  },
  components: {YJVideo, SearchKnowledge, CorrectPolyPhoneModal, AppSsmlEditor},
  mixins: [addLessonContentMixins],
  data() {
    const 内容文件选项 = Object.keys(MODULE_TYPE).map((key) => {
      return {
        value: key,
        label: MODULE_TYPE[key],
      };
    });
    return {
      type: "",
      blankWarning: false,
      inputValArr: [],
      markDownCheckBoxVal: false,
      creatAudioLoading: false,
      creatSayAudioLoading: false,
      loading: false,
      loadingA: false,
      loadingB: false,
      isLast: false,
      isSituational: false,
      dialogTitle: "",
      //当前角色
      roleArr: [
        {
          label: "老师",
          value: 1,
        },
        {
          label: "学生",
          value: 2,
        },
      ],
      roleArrStudent: [
        {
          label: "学生",
          value: 2,
        },
      ],
      // 切换的九个按钮
      内容文件选项: [...内容文件选项],
      //音频讲解
      humanOption: [
        {
          label: "老师",
          value: "zhiyuan",
        },
        {
          label: "学生",
          value: "zhigui",
        },
        {
          label: "标准女生",
          value: "sijia",
        },
        {
          label: "沉稳男生",
          value: "stanley",
        },
      ],
      rateArr: [
        {
          label: "慢",
          value: 0.8,
        },
        {
          label: "正常",
          value: 1.0,
        },
        {
          label: "快",
          value: 1.2,
        },
      ],
      titleAudioSrc: "",
      // 视频
      videoUrl: "",
      //图片
      imageUrl: "",
      //单选题
      selectTrueOptions: [
        {
          label: "选项A",
          value: 0,
        },
        {
          label: "选项B",
          value: 1,
        },
        {
          label: "选项C",
          value: 2,
        },
        {
          label: "选项D",
          value: 3,
        },
      ],
      //多选题
      multipleSelectTrueOptions: [
        {
          label: "A",
          value: 0,
        },
        {
          label: "B",
          value: 1,
        },
        {
          label: "C",
          value: 2,
        },
        {
          label: "D",
          value: 3,
        },
        {
          label: "E",
          value: 4,
        },
        {
          label: "F",
          value: 5,
        },
        {
          label: "G",
          value: 6,
        },
        {
          label: "H",
          value: 7,
        },
      ],
      //判断题
      judgeTrueOptions: [
        {
          label: "对",
          value: 0,
        },
        {
          label: "错",
          value: 1,
        },
      ],
      //排序题目
      sortTrueAnswer: null,
      //图片选择
      imageSelectAnswerOptions: [
        {
          label: "A",
          value: 0,
        },
        {
          label: "B",
          value: 1,
        },
      ],
      imageSelectUrlA: "",
      imageSelectUrlB: "",
    };
  },
  watch: {
    "formData.role": async function (newVal) {
      if (newVal === "学生") {
        this.defaultVoiceMethod("zhigui");
      } else {
        this.defaultVoiceMethod("zhiyuan");
      }
    },
  },
  computed: {
    ...mapState("courseCenter", ["editOutLineDetail"]),
    ...mapState("tenant", ["ossUploadObj"]),
    ...mapState("courseCenter", [
      "addLessonContentModalV1Visible",
      "audioDetail",
      "editOutLineDetail",
    ]),
    visible: {
      get() {
        return this.$store.state.courseCenter.addLessonContentModalV1Visible;
      },
      set(value) {
        this.$store.commit("courseCenter/setData", {
          key: "addLessonContentModalV1Visible",
          value,
        });
      },
    },
  },
  methods: {
    ...mapMutations("courseCenter", ["setData"]),
    ...mapActions("courseCenter", ["getAudioUrl"]),
    ...mapActions("tenant", ["generalUploadUrl"]),
    // ...mapMutations("polyPhone", ["setData"]),
    //点击转音频题干
    // handleToggleVideo(type, text) {
    //   // 文字转音频
    //   if (type === 1) {
    //     if (text && text.trim().length !== 0) {
    //       this.$message.warning("当前题干内容不为空，请清空后切换题干类型!");
    //       return;
    //     }
    //     this.formData.lessonContentTemplate.question.title = "";
    //     this.formData.lessonContentTemplate.question.titleAudio =
    //       "{{titleAudio}}";
    //   } else {
    //     // 音频转文字
    //     if (
    //       (text && text.trim().length !== 0) ||
    //       this.formData.lessonContentTemplate.materials[0].materialUrl
    //     ) {
    //       this.$message.warning("当前题干内容不为空，请清空后切换题干类型!");
    //       return;
    //     }
    //     this.formData.lessonContentTemplate.materials[0].audioText = "";
    //     this.formData.lessonContentTemplate.question.titleAudio = "";
    //   }
    //   this.$nextTick(() => {
    //     this.$refs.form.clearValidate();
    //   });
    // },
    //题干转音频
    handleChangeTitleAudio(val) {
      this.formData.lessonContentTemplate.material.audioText = val;
    },
    // 多音字弹框
    handleTitleAudioPolyPhone() {
      this.type = "audioText";
      const inputVal = this.formData.lessonContentTemplate.material.audioText;
      this.inputValArr = this.convertToObjects(inputVal);
      if (this.inputValArr.length < 1 || this.inputValArr.length > 300) {
        return;
      }
      this.$refs.CorrectPolyPhoneModal.visible = true;
    },
    // 生成音频
    async handleTitleAudio() {
      const inputVal = this.formData.lessonContentTemplate.material.audioText;
      this.inputValArr = this.convertToObjects(inputVal);
      if (this.inputValArr.length > 300) {
        return;
      }
      this.creatAudioLoading = true;
      if (!this.formData.lessonContentTemplate.material.audioText) {
        this.$message.warning("当前题干为空,不支持转音频");
        this.creatAudioLoading = false;
        return;
      }
      this.formData.lessonContentTemplate.material.audioSsmlText =
          this.creatSsmlText(
              this.formData.lessonContentTemplate.material.audioText
          );
      if (!this.formData.lessonContentTemplate.material.audioSsmlText) {
        this.$message.warning("当前题干为空,不支持转音频");
        this.creatAudioLoading = false;
        return;
      }
      await this.getAudioUrl({
        text: this.formData.lessonContentTemplate.material.audioSsmlText,
        speechRate: this.formData.lessonContentTemplate.material.speechRate,
        voice: this.formData.lessonContentTemplate.material.voice,
      });
      // 媒体名称
      this.formData.lessonContentTemplate.material.filename = this.audioDetail.filename;
      // 媒体ID
      this.formData.lessonContentTemplate.material.materialId = this.audioDetail.id;
      // 音频时长
      const audio = document.createElement("video");
      audio.src = this.audioDetail.url;
      audio.addEventListener("loadedmetadata", () => {
        if (Math.floor(audio.duration) === 0) {
          this.formData.lessonContentTemplate.material.duration = 1;
        } else {
          this.formData.lessonContentTemplate.material.duration = Math.floor(audio.duration);
        }
      });
      // 媒体类型
      this.formData.lessonContentTemplate.material.type = this.audioDetail.mimeType;
      // 媒体url
      this.formData.lessonContentTemplate.material.materialUrl = this.audioDetail.url;
      this.creatAudioLoading = false;
    },
    handleDeleteTitleAudio() {
      this.$confirm("请确认是否要清除当前音频内容?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(async () => {
            this.formData.lessonContentTemplate.material.materialUrl = "";
            this.formData.lessonContentTemplate.material.materialId = null;
            this.formData.lessonContentTemplate.material.duration = null;
            this.formData.lessonContentTemplate.material.filename = "";
            this.formData.lessonContentTemplate.material.audioText = "";
            this.formData.lessonContentTemplate.material.audioSsmlText = "";
            if (this.formData.role === "学生") {
              this.defaultVoiceMethod("zhigui");
            } else {
              this.defaultVoiceMethod("zhiyuan");
            }
          })
          .catch(() => {
          });
    },
    handleMarkDown(val) {
      if (val) {
        this.formData.lessonContentTemplate.material.markFlag = 1;
      } else {
        this.formData.lessonContentTemplate.material.markFlag = 0;
      }
    },
    handleChange(val) {
      this.formData.lessonContentTemplate.materials[0].audioText = val;
    },
    // 视频
    beforeUploadVideo(file) {
      if (!file.name.toLowerCase().endsWith("mp4")) {
        this.$message.error("上传视频仅支持mp4格式");
        return false; // 终止上传
      }
    },
    async handleVideoChange(file) {
      this.loading = true;
      const isJPG = file.raw.name.split(".")[1].toLowerCase();
      if (!file.raw.name.toLowerCase().endsWith("mp4")) {
        this.$message.error("上传视频只能是 MP4格式!");
        this.loading = false;
        return;
      }
      await this.generalUploadUrl({
        contentType: file.raw.type,
      });
      const fileName = encodeURIComponent(file.raw.name);
      // this.form.avatar = this.ossUploadObj.filename
      const obj = {
        "Content-Disposition": "attachment;filename=" + '"' + fileName + '"',
        "Content-Type": file.raw.type,
      };
      this.$axios.defaults.withCredentials = false;
      await this.$axios({
        url: this.ossUploadObj.url,
        method: "put",
        isUpload: true,
        data: file.raw,
        headers: obj,
      })
          .then((res) => {
            console.log(res);
            this.videoUrl = URL.createObjectURL(file.raw);
            this.formData.lessonContentTemplate.materials[0].filename =
                this.ossUploadObj.filename;
            // 获取视频时长
            const video = document.createElement("video");
            video.src = URL.createObjectURL(file.raw);
            video.addEventListener("loadedmetadata", () => {
              if (Math.floor(video.duration) === 0) {
                this.formData.lessonContentTemplate.materials[0].duration = 1;
              } else {
                this.formData.lessonContentTemplate.materials[0].duration =
                    Math.floor(video.duration);
              }
            });
            this.loading = false;
          })
          .catch((e) => {
            this.loading = false;
            this.$message.error("视频上传失败，请重新上传");
            this.videoUrl = "";
            console.log(e);
          });
      this.$axios.defaults.withCredentials = true;
    },
    handleUploadNewVideo() {
      this.videoUrl = "";
    },
    //图片
    async handleImgChange(file) {
      this.loading = true;
      const isJPG =
          file.raw.type === "image/jpeg" ||
          file.raw.type === "image/png" ||
          file.raw.type === "image/gif";
      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG/PNG/GIF!");
        this.loading = false;
        return;
      }
      await this.generalUploadUrl({
        contentType: file.raw.type,
      });
      const fileName = encodeURIComponent(file.raw.name);
      // this.form.avatar = this.ossUploadObj.filename
      const obj = {
        "Content-Disposition": "attachment;filename=" + '"' + fileName + '"',
        "Content-Type": file.raw.type,
      };
      this.$axios.defaults.withCredentials = false;
      await this.$axios({
        url: this.ossUploadObj.url,
        method: "put",
        isUpload: true,
        data: file.raw,
        headers: obj,
      })
          .then((res) => {
            console.log(res);
            console.log(this.ossUploadObj);
            this.imageUrl = URL.createObjectURL(file.raw);
            this.formData.lessonContentTemplate.materials[0].filename =
                this.ossUploadObj.filename;
            this.loading = false;
          })
          .catch((e) => {
            this.loading = false;
            console.log(e);
            this.$message.error("图片上传失败，请重新上传");
            this.imageUrl = "";
          });
      this.$axios.defaults.withCredentials = true;
    },
    beforeImageUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG/PNG!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    handleGroupTitleAudioPolyPhone() {
      this.type = "question";
      const inputVal =
          this.formData.lessonContentTemplate.materials[0].audioText;
      this.inputValArr = this.convertToObjects(inputVal);
      if (this.inputValArr.length < 1 || this.inputValArr.length > 300) {
        return;
      }
      this.$refs.CorrectPolyPhoneModal.visible = true;
    },
    //选择 判断图 排序 图片选择  生成音频
    async handleGroupTitleAudio() {
      const inputVal =
          this.formData.lessonContentTemplate.materials[0].audioText;
      this.inputValArr = this.convertToObjects(inputVal);
      if (this.inputValArr.length > 300) {
        return;
      }
      this.creatAudioLoading = true;
      if (!this.formData.lessonContentTemplate.materials[0].audioText) {
        this.$message.warning("当前题干为空,不支持转音频");
        this.creatAudioLoading = false;
        return;
      }
      this.formData.lessonContentTemplate.materials[0].audioSsmlText =
          this.creatSsmlText(
              this.formData.lessonContentTemplate.materials[0].audioText
          );
      if (!this.formData.lessonContentTemplate.materials[0].audioSsmlText) {
        this.$message.warning("当前题干为空,不支持转音频");
        this.creatAudioLoading = false;
        return;
      }
      await this.getAudioUrl({
        text: this.formData.lessonContentTemplate.materials[0].audioSsmlText,
        speechRate: this.formData.lessonContentTemplate.materials[0].speechRate,
        voice: this.formData.lessonContentTemplate.materials[0].voice,
      });
      //音频url
      this.titleAudioSrc = this.audioDetail.url;
      // 媒体名称
      this.formData.lessonContentTemplate.materials[0].filename =
          this.audioDetail.filename;
      // 媒体ID
      this.formData.lessonContentTemplate.materials[0].materialId =
          this.audioDetail.id;
      // 音频时长
      const audio = document.createElement("video");
      audio.src = this.audioDetail.url;
      audio.addEventListener("loadedmetadata", () => {
        if (Math.floor(audio.duration) === 0) {
          this.formData.lessonContentTemplate.materials[0].duration = 1;
        } else {
          this.formData.lessonContentTemplate.materials[0].duration =
              Math.floor(audio.duration);
        }
      });
      // 媒体类型
      this.formData.lessonContentTemplate.materials[0].type =
          this.audioDetail.mimeType;
      // 题目音频类型
      this.formData.lessonContentTemplate.question.titleAudioType =
          this.audioDetail.mimeType;
      // 题目音频url
      this.formData.lessonContentTemplate.materials[0].materialUrl =
          this.audioDetail.url;
      // 题目音频类型
      this.formData.lessonContentTemplate.question.titleAudio =
          "{{titleAudio}}";
      this.creatAudioLoading = false;
    },
    handleDeleteGroupTitleAudio() {
      this.$confirm("请确认是否要清除当前音频内容?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(async () => {
            this.formData.lessonContentTemplate.materials[0].materialUrl = "";
            this.formData.lessonContentTemplate.materials[0].audioText = "";
            this.formData.lessonContentTemplate.materials[0].audioSsmlText = "";
            this.formData.lessonContentTemplate.materials[0].filename = "";
            this.formData.lessonContentTemplate.materials[0].materialId = null;
            this.formData.lessonContentTemplate.materials[0].duration = null;
            if (this.formData.role === "学生") {
              this.defaultVoiceMethod("zhigui");
            } else {
              this.defaultVoiceMethod("zhiyuan");
            }
          })
          .catch(() => {
          });
    },
    handleSelectAnswer(val) {
      const selectItem = this.formData.lessonContentTemplate.question.item[val];
      if (!selectItem || selectItem.trim().length < 1) {
        this.$confirm("您选择的正确选项内容为空,请检查后重试!", "提示", {
          confirmButtonText: "确定",
          showCancelButton: false,
          type: "warning",
        })
            .then(async () => {
            })
            .catch(() => {
            });
        this.formData.lessonContentTemplate.question.answer = [];
      }
    },
    async handleImgSelectChangeA(file) {
      this.loadingA = true;
      const isJPG =
          file.raw.type === "image/jpeg" ||
          file.raw.type === "image/png" ||
          file.raw.type === "image/gif";
      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG/PNG/GIF!");
        this.loadingA = false;
        return;
      }
      await this.generalUploadUrl({
        contentType: file.raw.type,
      });
      const fileName = encodeURIComponent(file.raw.name);
      // this.form.avatar = this.ossUploadObj.filename
      const obj = {
        "Content-Disposition": "attachment;filename=" + '"' + fileName + '"',
        "Content-Type": file.raw.type,
      };
      this.$axios.defaults.withCredentials = false;
      await this.$axios({
        url: this.ossUploadObj.url,
        method: "put",
        isUpload: true,
        data: file.raw,
        headers: obj,
      })
          .then((res) => {
            console.log(res);
            this.imageSelectUrlA = URL.createObjectURL(file.raw);
            this.formData.lessonContentTemplate.materials[1].filename =
                this.ossUploadObj.filename;
            this.loadingA = false;
          })
          .catch((e) => {
            this.loadingA = false;
            console.log(e);
            this.$message.error("上传失败，请重新上传！");
            this.imageSelectUrlA = "";
          });
      this.$axios.defaults.withCredentials = true;
    },
    beforeImgSelectUploadA(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG/PNG/GIF!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    //B选项
    async handleImgSelectChangeB(file) {
      this.loadingB = true;
      const isJPG =
          file.raw.type === "image/jpeg" ||
          file.raw.type === "image/png" ||
          file.raw.type === "image/gif";
      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG/PNG/GIF!");
        this.loadingB = false;
        return;
      }
      await this.generalUploadUrl({
        contentType: file.raw.type,
      });
      const fileName = encodeURIComponent(file.raw.name);
      // this.form.avatar = this.ossUploadObj.filename
      const obj = {
        "Content-Disposition": "attachment;filename=" + '"' + fileName + '"',
        "Content-Type": file.raw.type,
      };
      this.$axios.defaults.withCredentials = false;
      await this.$axios({
        url: this.ossUploadObj.url,
        method: "put",
        isUpload: true,
        data: file.raw,
        headers: obj,
      })
          .then((res) => {
            console.log(res);
            this.imageSelectUrlB = URL.createObjectURL(file.raw);
            this.formData.lessonContentTemplate.materials[2].filename =
                this.ossUploadObj.filename;
            this.loadingB = false;
          })
          .catch((e) => {
            this.loadingB = false;
            console.log(e);
            this.$message.error("上传失败，请重新上传！");
            this.imageSelectUrlB = "";
          });
      this.$axios.defaults.withCredentials = true;
    },
    beforeImgSelectUploadB(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG/PNG!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    // 图片正确选项发生变化时候
    handleImageTrueAnswer() {
      if (!this.imageSelectUrlA || !this.imageSelectUrlB) {
        this.$message.warning("请先补充选项");
        this.formData.lessonContentTemplate.question.answer = [];
      }
    },
    //讲解
    handleChangeSayAudio(val) {
      this.formData.lessonContentTemplate.materials[3].audioText = val;
    },
    handleSayAudioPolyPhone() {
      this.type = "explain";
      const inputVal =
          this.formData.lessonContentTemplate.materials[3].audioText;
      this.inputValArr = this.convertToObjects(inputVal);
      if (this.inputValArr.length < 1 || this.inputValArr.length > 300) {
        return;
      }
      this.$refs.CorrectPolyPhoneModal.visible = true;
    },
    async handleSayAudio() {
      const inputVal =
          this.formData.lessonContentTemplate.materials[3].audioText;
      this.inputValArr = this.convertToObjects(inputVal);
      if (this.inputValArr.length > 300) {
        return;
      }
      this.creatSayAudioLoading = true;
      if (!this.formData.lessonContentTemplate.materials[3].audioText) {
        this.$message.warning("当前音频讲解内容为空,不支持转音频");
        this.creatSayAudioLoading = false;
        return;
      }
      this.formData.lessonContentTemplate.materials[3].audioSsmlText =
          this.creatSsmlText(
              this.formData.lessonContentTemplate.materials[3].audioText
          );
      if (!this.formData.lessonContentTemplate.materials[3].audioSsmlText) {
        this.$message.warning("当前音频讲解内容为空,不支持转音频");
        this.creatSayAudioLoading = false;
        return;
      }
      await this.getAudioUrl({
        text: this.formData.lessonContentTemplate.materials[3].audioSsmlText,
        speechRate: this.formData.lessonContentTemplate.materials[3].speechRate,
        voice: this.formData.lessonContentTemplate.materials[3].voice,
      });
      // 媒体名称
      this.formData.lessonContentTemplate.materials[3].filename =
          this.audioDetail.filename;
      // 媒体ID
      this.formData.lessonContentTemplate.materials[3].materialId =
          this.audioDetail.id;
      // 音频时长
      const audio = document.createElement("video");
      audio.src = this.audioDetail.url;
      audio.addEventListener("loadedmetadata", () => {
        if (Math.floor(audio.duration) === 0) {
          this.formData.lessonContentTemplate.materials[3].duration = 1;
        } else {
          this.formData.lessonContentTemplate.materials[3].duration =
              Math.floor(audio.duration);
        }
      });
      // 媒体类型
      this.formData.lessonContentTemplate.materials[3].type =
          this.audioDetail.mimeType;
      // 讲解音频类型
      this.formData.lessonContentTemplate.materials[3].materialUrl =
          this.audioDetail.url;
      // 讲解音频类型
      this.formData.lessonContentTemplate.question.explainAudioType =
          this.audioDetail.mimeType;
      // 占位符
      this.formData.lessonContentTemplate.question.explainAudio =
          "{{explainAudio}}";
      this.creatSayAudioLoading = false;
    },
    handleDeleteSayAudio() {
      this.$confirm("请确认是否要清除当前音频内容?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(async () => {
            this.formData.lessonContentTemplate.materials[3].materialUrl = "";
            this.formData.lessonContentTemplate.materials[3].materialId = null;
            this.formData.lessonContentTemplate.materials[3].duration = null;
            this.formData.lessonContentTemplate.materials[3].filename = "";
            this.formData.lessonContentTemplate.materials[3].audioText = "";
            this.formData.lessonContentTemplate.materials[3].audioSsmlText = "";
            if (this.formData.role === "学生") {
              this.defaultVoiceMethod("zhigui");
            } else {
              this.defaultVoiceMethod("zhiyuan");
            }
          })
          .catch(() => {
          });
    },
    // 本本本本
    handleOpen() {
      this.clearForm();
      this.initForm();
      if (this.type === "audioText") {
        this.$refs.audioTextEdit.blurEditor();
      }
      if (this.type === "question") {
        this.$refs.questionEdit.blurEditor();
      }
      if (this.type === "explain") {
        this.$refs.explainEdit.blurEditor();
      }
    },
    // },
    // 声音属性默方法
    defaultVoiceMethod(voice) {
      if (this.isSituational) {
        this.formData.lessonContentTemplate.materials[3].voice = voice;
        this.formData.lessonContentTemplate.materials[3].speechRate = 1.0;
      }
      if (
          this.formData.type === "select" ||
          this.formData.type === "multipleSelect" ||
          this.formData.type === "judge" ||
          this.formData.type === "sort" ||
          this.formData.type === "text" ||
          this.formData.type === "imageSelect"
      ) {
        this.formData.lessonContentTemplate.materials[0].voice = voice;
        this.formData.lessonContentTemplate.materials[0].speechRate = 1.0;
      }
      if (this.formData.type === "audioText") {
        this.formData.lessonContentTemplate.material.voice = voice;
        this.formData.lessonContentTemplate.material.speechRate = 1.0;
      }
    },
    //更换type
    handleChangeType(val) {
      this.clearForm();
      this.initForm();
      this.formData.type = val;
      if (this.formData.role === "学生") {
        this.defaultVoiceMethod("zhigui");
      } else {
        this.defaultVoiceMethod("zhiyuan");
      }
      if (
          this.formData.type === "text" ||
          this.formData.type === "dialogSelect"
      ) {
        this.formData.role = "学生";
      } else {
        this.formData.role = "老师";
      }
    },
    //保存查看
    async handleSave() {
      await this.$refs.form.validate(async (valid) => {
        if (valid) {
          const res = await this.handleCommit();
          if (res) {
            if (this.addType === "downAdd") {
              this.formData.operateOffset = JSON.parse(
                  localStorage.getItem("operateOffset")
              );
              await this.addBelowLessonContent({
                ...this.formData,
              });
            } else {
              await this.saveLessonContent({
                ...this.formData,
              });
            }
            this.$message.success("操作成功");
            await this.$emit("initTable");
            this.setData({
              key: "addLessonContentModalV1Visible",
              value: false,
            });
          }
        }
      });
    },
    //继续添加
    async handleAdd() {
      await this.$refs.form.validate(async (valid) => {
        if (valid) {
          const res = await this.handleCommit();
          if (res) {
            if (this.addType === "downAdd") {
              this.formData.operateOffset = JSON.parse(
                  localStorage.getItem("operateOffset")
              );
              await this.addBelowLessonContent({
                ...this.formData,
              });
            } else {
              await this.saveLessonContent({
                ...this.formData,
              });
            }
            this.$message.success("操作成功");
            await this.$emit("initTable");
            await this.clearForm();
            this.initForm();
          }
        }
      });
    },
    //进入下一模块
    async handleNextModule() {
      await this.$refs.form.validate(async (valid) => {
        if (valid) {
          const res = await this.handleCommit();
          if (res) {
            await this.saveLessonContent({
              ...this.formData,
            });
            await this.$emit("initTable");
            this.$message.success("操作成功");
            let index = JSON.parse(localStorage.getItem("moduleIndex")) + 1;
            localStorage.setItem("moduleIndex", JSON.stringify(index));
            localStorage.setItem(
                "modelItem",
                JSON.stringify(this.editOutLineDetail.outline[index])
            );
            this.clearForm();
            this.initForm();
            this.$emit("activeItem");
            await this.$emit("initTable");
            if (index + 1 === this.editOutLineDetail.outline.length) {
              this.isLast = true;
            }
          }
        }
      });
    },
    // 最后一个完成按钮
    async handleFinished() {
      await this.$refs.form.validate(async (valid) => {
        if (valid) {
          const res = await this.handleCommit();
          if (res) {
            if (this.addType === "downAdd") {
              this.formData.operateOffset = JSON.parse(
                  localStorage.getItem("operateOffset")
              );
              await this.addBelowLessonContent({
                ...this.formData,
              });
            } else {
              await this.saveLessonContent({
                ...this.formData,
              });
            }
            this.$message.success("操作成功");
            await this.$emit("initTable");
            await this.setData({
              key: "addLessonContentModalV1Visible",
              value: false,
            });
          }
        }
      });
    },
    async handleClose() {
      await this.setData({
        key: "addLessonContentModalV1Visible",
        value: false,
      });
    },
    //初始化表单方法，包括回显、清空等
    initForm() {
      console.log("initForm")
      let index = JSON.parse(localStorage.getItem("moduleIndex"));
      if (this.addType != "view") {
        this.isLast = index + 1 === this.editOutLineDetail.outline.length;
      }

      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });

      this.formData.role = "老师";
      const 内容文件选项 = Object.keys(MODULE_TYPE).map((key) => {
        return {
          value: key,
          label: MODULE_TYPE[key],
        };
      });
      this.内容文件选项 = 内容文件选项;
      if (this.addType === "add") {
        const modelItem = JSON.parse(localStorage.getItem("modelItem"));
        //判断是否是随堂测试环节，如果是，则所有题题型有错题讲解
        this.isSituational = modelItem.module === "随堂测试";
        let modelType;
        // 判断是否是用户自定义的大纲
        if (modelItem.type === "custom") {
          this.formData.type = this.内容文件选项[0].value;
          this.formData.model = modelItem.module;
          this.formData.modelId = modelItem.id;
          this.formData.lessonId = this.editOutLineDetail.lessonId;
          this.formData.version = this.editOutLineDetail.version;
          this.dialogTitle = modelItem.module;
          this.内容文件选项 = this.内容文件选项.slice(
              0,
              this.内容文件选项.length - 1
          );
        } else {
          // 判断是否有多种表现形式
          if (modelItem.type.indexOf(",") === -1) {
            modelType = modelItem.type.split();
          } else {
            modelType = modelItem.type.split(",");
          }
          // 转成数组后，过滤出来当前表现形式的数组，进行赋值
          const arr = this.内容文件选项.filter((item1) =>
              modelType.some((item2) => item1.value === item2)
          );
          this.内容文件选项 = arr;
          this.formData.type = this.内容文件选项[0].value;
          this.formData.model = modelItem.module;
          this.formData.modelId = modelItem.id;
          this.formData.lessonId = this.editOutLineDetail.lessonId;
          this.formData.version = this.editOutLineDetail.version;
          this.dialogTitle = modelItem.module;
        }
        this.defaultVoiceMethod("zhiyuan");
        if (
            this.formData.type === "text" ||
            this.formData.type === "dialogSelect"
        ) {
          this.formData.role = "学生";
        }
        this.markDownCheckBoxVal = false;
      } else if (this.addType === "edit" || this.addType === "view") {
        const lessonContentRow = JSON.parse(
            localStorage.getItem("lessonContentRow")
        );
        var lessonContentDetail;
        lessonContentDetail = JSON.parse(JSON.stringify(lessonContentRow));
        const arr = this.内容文件选项.filter(
            (item) => item.value == lessonContentDetail.type
        );
        this.内容文件选项 = arr;
        //判断是否是随堂测试环节，如果是，则所有题题型有错题讲解
        this.isSituational = lessonContentDetail.model === "随堂测试";
        this.formData.id = lessonContentDetail.id;
        this.formData.type = lessonContentDetail.type;
        this.formData.model = lessonContentDetail.model;
        this.formData.modelId = lessonContentDetail.modelId;
        this.formData.lessonId = lessonContentDetail.lessonId;
        this.formData.version = lessonContentDetail.version;
        this.dialogTitle = lessonContentDetail.model;
        this.formData.role = lessonContentDetail.content.role;

        this.formData.lessonContentTemplate = lessonContentDetail.content;

        if (
            lessonContentDetail.type === "image" ||
            lessonContentDetail.type === "richText"
        ) {
          this.imageUrl = lessonContentDetail.content.materials[0].materialUrl;
        }
        if (lessonContentDetail.type === "sort") {
          this.sortTrueAnswer =
              this.formData.lessonContentTemplate.question.answer.join("");
        }
        if (lessonContentDetail.type === "imageSelect") {
          this.imageSelectUrlA =
              lessonContentDetail.content.materials[1].materialUrl;
          this.imageSelectUrlB =
              lessonContentDetail.content.materials[2].materialUrl;
        }
        if (lessonContentDetail.type === "video") {
          this.videoUrl = lessonContentDetail.content.materials[0].materialUrl;
        }
        if (
            this.formData.type === "text" ||
            this.formData.type === "dialogSelect"
        ) {
          this.formData.role = "学生";
        }
        this.markDownCheckBoxVal =
            this.formData.type === "audioText" &&
            this.formData.lessonContentTemplate.material.markFlag === 1;
      } else if (this.addType === "downAdd") {
        const modelItem = JSON.parse(localStorage.getItem("modelItem"));
        //判断是否是随堂测试环节，如果是，则所有题题型有错题讲解
        if (modelItem.module === "随堂测试") {
          this.isSituational = true;
        } else {
          this.isSituational = false;
        }
        let modelType;
        // 判断是否是用户自定义的大纲
        if (modelItem.type === "custom") {
          this.formData.type = this.内容文件选项[0].value;
          this.formData.model = modelItem.module;
          this.formData.modelId = modelItem.id;
          this.formData.lessonId = this.editOutLineDetail.lessonId;
          this.formData.version = this.editOutLineDetail.version;
          this.dialogTitle = modelItem.module;
          this.内容文件选项 = this.内容文件选项.slice(
              0,
              this.内容文件选项.length - 1
          );
        } else {
          // 判断是否有多种表现形式
          if (modelItem.type.indexOf(",") === -1) {
            modelType = modelItem.type.split();
          } else {
            modelType = modelItem.type.split(",");
          }
          // 转成数组后，过滤出来当前表现形式的数组，进行赋值
          const arr = this.内容文件选项.filter((item1) =>
              modelType.some((item2) => item1.value === item2)
          );
          this.内容文件选项 = arr;
          this.formData.type = this.内容文件选项[0].value;
          this.formData.model = modelItem.module;
          this.formData.modelId = modelItem.id;
          this.formData.lessonId = this.editOutLineDetail.lessonId;
          this.formData.version = this.editOutLineDetail.version;
          this.dialogTitle = modelItem.module;
        }
        this.defaultVoiceMethod("zhiyuan");
        if (
            this.formData.type === "text" ||
            this.formData.type === "dialogSelect"
        ) {
          this.formData.role = "学生";
        }
        this.markDownCheckBoxVal =
            this.formData.type === "audioText" &&
            this.formData.lessonContentTemplate.material.markFlag === 1;
      }
      console.log(this.formData);
    },
    // 返回纯文本数组
    convertToObjects(inputVal) {
      const objects = [];
      if (!inputVal) {
        return objects;
      }
      const regex = /(<strong.*?>.*?<\/strong>)|./g;
      const result = inputVal.match(regex);
      var newResult = [];
      for (let i = 0; i < result.length; i++) {
        if (result[i].trim().length > 1) {
          if (!result[i].includes("color: rgb(16, 104, 156)")) {
            const div = document.createElement("div");
            div.innerHTML = result[i];
            let text = div.textContent || div.innerText;
            newResult.push(text);
          } else {
            const div = document.createElement("div");
            div.innerHTML = result[i];
            let text = div.textContent || div.innerText;
            newResult.push("{{{" + text + "}}}");
          }
        } else {
          newResult.push(result[i]);
        }
      }
      const str = newResult.join("");
      const div = document.createElement("div");
      div.innerHTML = str;
      let newStr = div.textContent || div.innerText;
      const regex2 = /({{{.*?}}})|./g;
      const result2 = newStr.match(regex2);
      for (let i = 0; i < result2.length; i++) {
        const item = result2[i];
        if (item.length > 1) {
          const regex = /\{\{\{(.+?)\}\}\}/g;
          const match = item.replace(regex, "$1");
          if (match && match.length >= 2) {
            const extractedText = match.trim();
            const cha = extractedText.split("]")[1];
            const pinyin = extractedText.split("]")[0].split("[")[1];
            objects.push({cha: cha, pinyin: pinyin});
          }
        } else {
          objects.push({cha: item, pinyin: ""});
        }
      }
      return objects;
    },
    // 选择多音字发音弹框确定按钮传过来的富文本编辑器回显inputVal
    refreshInputVal(audioText) {
      if (this.type === "audioText") {
        this.formData.lessonContentTemplate.material.audioText = audioText;
        this.$refs.audioTextEdit.blurEditor();
      }
      if (this.type === "question") {
        this.formData.lessonContentTemplate.materials[0].audioText = audioText;
        this.$refs.questionEdit.blurEditor();
      }
      if (this.type === "explain") {
        this.formData.lessonContentTemplate.materials[3].audioText = audioText;
        this.$refs.explainEdit.blurEditor();
      }
      this.$nextTick(() => {
        this.disabledEdit();
      });
    },
    // 解析为ssml文本，生成音频
    creatSsmlText(val) {
      const characterArr = this.convertToObjects(val);
      if (characterArr.length < 1) {
        return "";
      }
      const ssmlText = characterArr
          .map((item) => {
            if (item.pinyin !== "") {
              return `<phoneme alphabet='py' ph='${item.pinyin}'>${item.cha}</phoneme>`;
            } else {
              return item.cha;
            }
          })
          .join("");
      return "<speak>" + ssmlText + "</speak>";
    },
    // 多音字不可编辑部分
    disabledEdit() {
      let paragraphs = document.querySelectorAll("p");
      paragraphs.forEach(function (paragraph) {
        let strongArr = paragraph.querySelectorAll("strong");
        strongArr.forEach(function (strong) {
          if (getComputedStyle(strong).color === "rgb(16, 104, 156)") {
            strong.setAttribute("contenteditable", "false");
          }
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.AddLessonContentModal {
  ::v-deep .el-dialog {
    min-width: 900px;
    height: 800px;
  }

  ::v-deep .el-dialog .el-dialog__body {
    padding: 20px 35px;
  }

  ::v-deep .el-dialog__close {
    z-index: 999;
  }

  ::v-deep .el-form-item {
    margin-bottom: 10px !important;
  }

  ::v-deep .el-button--primary.is-plain {
    color: #10689c;
    background: #f0f2fa;
    border-color: #c1cbea;
  }

  ::v-deep .el-button--primary.is-plain:hover {
    color: #10689c;
    background: #f0f2fa;
    border-color: #c1cbea;
  }

  ::v-deep .el-button--info.is-plain {
    color: #8f8f8f;
    background: #f4f4f4;
    border-color: #d2d2d2;
  }

  ::v-deep .el-button--info.is-plain:hover {
    color: #8f8f8f;
    background: #f4f4f4;
    border-color: #d2d2d2;
  }

  .sortBox {
    .requiredSort {
      ::v-deep .el-input__inner {
        border: 1px solid #f56c6c;
      }
    }

    ::v-deep .el-form-item__label::before {
      content: "*";
      color: #f56c6c;
      margin-right: 4px;
    }
  }

  .title {
    font-size: 16px;
    color: #333333;
    font-weight: bold;
    margin-bottom: 10px;
  }

  .contentChangeBox {
    background: #f2f2f2;
    padding: 15px 10px 10px 0;
    border-radius: 3px;
    margin-top: 15px;
    min-height: 310px;

    ::v-deep .el-form-item {
      margin-bottom: 15px !important;
    }

    .unShowStar {
      ::v-deep
      .el-form-item.is-required:not(.is-no-asterisk)
      > .el-form-item__label:before {
        content: "";
      }
    }

    .itemBox {
      width: 100%;
      background: #ffffff;
      padding: 10px;
      border: 1px solid #dcdfe6;
      border-radius: 4px;
    }

    //题干转音频
    .changeTitleTypeBox {
      margin-left: 90px;
      margin-top: 20px;
      margin-bottom: 10px;
      display: flex;
      justify-content: space-between;
    }

    ::v-deep .el-textarea__inner {
      min-height: 100px !important;
    }

    //图片
    .avatar-uploader .el-upload {
      border: 1px solid #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
      border-color: #409eff;
    }

    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 100px;
      height: 100px;
      line-height: 100px;
      text-align: center;
      border: 1px solid #dcdfe6;
      margin-bottom: 20px;
    }

    .avatar {
      width: 100px;
      height: 100px;
      display: block;
      margin-bottom: 10px;
    }

    .btn {
      text-align: right;
    }

    .explainBox {
      .explainTitle {
        width: 83px;
        text-align: right;
        font-size: 15px;
        font-weight: bold;
        color: #333333;
        margin-bottom: 20px;

        .changeTitleTypeBox1 {
          width: 100%;
          display: flex;
          justify-content: space-between !important;
          align-items: flex-start;
        }
      }
    }
  }

  .footer {
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin-top: 20px;
  }
}
</style>
